import type {
  AdminInAppReferralCompaniesParams,
  AdminInAppReferralLeadsParams,
  InAppReferralLeadsParams,
} from './types';

export const inAppReferralsKeys = {
  all: ['in-app-referrals'] as const,
  forCompany: (companyId: number) =>
    [...inAppReferralsKeys.all, 'company', companyId] as const,
  leadLists: () => [...inAppReferralsKeys.all, 'leads'] as const,
  leadList: (params: InAppReferralLeadsParams) =>
    [...inAppReferralsKeys.leadLists(), params] as const,
  adminLeadLists: () => [...inAppReferralsKeys.all, 'admin', 'leads'] as const,
  adminLeadList: (params: AdminInAppReferralLeadsParams) =>
    [...inAppReferralsKeys.adminLeadLists(), params] as const,
  adminSummaries: () =>
    [...inAppReferralsKeys.all, 'admin', 'summary'] as const,
  adminSummary: (params: AdminInAppReferralLeadsParams) =>
    [...inAppReferralsKeys.adminSummaries(), params] as const,
  adminCompanyLists: () =>
    [...inAppReferralsKeys.all, 'admin', 'companies'] as const,
  adminCompanyList: (params: AdminInAppReferralCompaniesParams) =>
    [...inAppReferralsKeys.adminCompanyLists(), params] as const,
} as const;
